import { Pipe, PipeTransform } from '@angular/core';
import { hasPermissionTransform, hasAnyPermissionTransform } from './util';

@Pipe({ name: 'hasPermission' })
export class HasPermissionPipe implements PipeTransform {

    constructor() {
    }

    transform(permissionValue: string, permissionAllKeys: string[], expectedPermissionKey: string) {
        return hasPermissionTransform(permissionValue, permissionAllKeys, expectedPermissionKey);
    }
}

@Pipe({ name: 'hasAnyPermission' })
export class HasAnyPermissionPipe implements PipeTransform {

    constructor() {
    }

    transform(permissionValue: string, permissionAllKeys: string[], expectedPermissionKeys: string[]) {
        return hasAnyPermissionTransform(permissionValue, permissionAllKeys, expectedPermissionKeys);
    }
}
